<template>
  <div class="picture-modal-template">
    <b-button size="sm" variant="outline-secondary" v-on:click="show" v-if="this.config.add_button_html">
      {{this.config.add_button_html}}
    </b-button>
    <b-modal
      id='pictureModal'
      :ref="'pictureModal'"
      :modal-class="[ 'picture-modal-template', modalClass ]"
      class="text-sm-left"
      centered
      hide-footer
      @hidden="hide"
    >
      <!-- Header -->
      <template slot="modal-header">
        <div class="modal-photo-container">
          <picture-placeholder
            :textIn="config.modalTitle || config.title"
            :pictureUrl="config.pictureUrl"
          />
        </div>

        <div class="modal-toolbar">
          <slot name="modal-toolbar-buttons">
            <span class="modal-btn" v-on:click="hideModal">
              <i class="fi-x cancel-bro nav-icon" />
            </span>
          </slot>
        </div>

        <h4 class="modal-title">
          {{ overrideTitle || config.title }}
        </h4>

        <b-nav class="modal-nav-bar">
          <b-nav-item
            v-for="(view, index) in views"
             class=""
            :class="['modal-nav-link', { 'navLinkActive': view && view.title == views[currentActive].title } ]"
            :key="index"
            @click="currentActive=index"
          >
            {{ view ? view.title.toUpperCase() : '' }}
          </b-nav-item>
        </b-nav>
      </template>

      <!-- Content -->
      <div
        v-for="(view, index) in views"
        :class="[ 'modal-slot-container', { 'hidden': currentActive != index } ]"
        :key="'slot_' + index"
      >
        <slot v-if="view" :name="view.id"></slot>
      </div>
      <slot name="button"></slot>

    </b-modal>
  </div>
</template>

<script>
import PicturePlaceholder from "@/components/widgets/PicturePlaceholder";

export default {
  components: {
    PicturePlaceholder
  },
  props: {
    handleSubmit: Function,
    views: Array,
    config: Object,
    overrideTitle: String,
    modalClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentActive: 0
    };
  },
  methods: {
    hideModal() {
      this.$refs.pictureModal.hide();
      this.currentActive = 0;
    },

    hide() {
      this.$emit("hide");
    },

    show(_event, _record) {
      this.$refs.pictureModal.show();
      this.$emit("show", _event, _record);
    },

    setActiveTab(id) {
      if (isNaN(parseInt(id)) || id >= this.views.length) {
        return ;
      }
      this.currentActive = id
    }
  }
};
</script>

<style lang="scss">
  .picture-modal-template {
    .modal {
      border-radius: 50px;
      position: fixed;
    }

    .modal-content {
      border-radius: 22px;
      border: none;
    }

    .modal-dialog {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) !important;
      margin: 0px;
      border-radius: 20px;
      max-width: 650px;
    }

    .modal-header {
      color: white;
      background: #636975;
      border: 1px solid #636975;
      padding-left: 20px;
      padding-top: 24px;
      height: 147px;
      border-radius: 20px 20px 0px 0px;
      position: relative;
    }

    .modal-nav-bar {
      position: absolute;
      left: 149px;
      bottom: -1px;
      flex-wrap: nowrap;
    }

    .modal-nav-link {
      width: 100px;
      text-align: center;
      padding: none;
    }

    .modal-toolbar {
      position: absolute;
      right: 0px;
      top: 0px;
      right: 16px;
      top: 16px;
    }

    .navLinkActive a {
      border-bottom: 4px solid orange;
      color: #fff !important;
    }

    .modal-nav-link:hover a {
      border-bottom: 4px solid orange;
      color: #fff !important;
    }

    .modal-nav-link a {
      color: #ddd;
      font-size: 12pt;
      padding: 5px;
      transition: all 0.15s ease-in-out;
    }

    .modal-body {
      background: #f9f9f9;
      padding-top: 72px;
      border-radius: 0px 0px 20px 20px;
      height: 400px;
      position: relative;
      overflow: auto;
    }

    .modal-photo-container {
      background-color: rgb(156, 156, 156);
      height: 128px;
      width: 128px;
      position: absolute;
      left: 20px;
      bottom: 0%;
      transform: translateY(50%);
      border: solid 6px #f9f9f9;
      border-radius: 50%;
      z-index: 1;
      overflow: hidden;
    }

    .hidden {
      display: none !important;
    }

    .modal-slot-container {
      /* transition: all 1s ease-in-out; */
    }

    .modal-btn {
      width: 32px;
      height: 32px;
      cursor: pointer;
      transition: all 0.15s ease-in-out;
    }

    .modal-btn:hover {
      opacity: 0.7;
    }

    .modal-asset-icon {
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      width: 32px;
      height: 32px;
    }

    .nav-icon {
      font-size: 1.5rem;
      padding: 5px;
    }
  }
</style>
